import React from 'react';

import { ia } from 'lib/helpers/utility';
import { formatDate } from 'lib/helpers/dateUtils';
import { useUIContext } from 'lib/context/UIContext/UIContext';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';

import { insuranceTypes } from '../lib/constants';
import NestedItems from '../components/NestedItems';

const DetailsCell = ({ data }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';
  const {
    details = '',
    type,
    procedure_code,
    diagnosis_code,
    dateofservice,
    from_date,
    qty,
    procedures: nestedProcedures,
    products: nestedProducts
  } = data || {};

  const formattedDateOfService = formatDate(dateofservice);
  const isSameDate = from_date === formattedDateOfService;
  const showQty = qty > 1;
  const hasNested = ia(nestedProcedures) || ia(nestedProducts);

  if (isMobile) {
    return (
      <div className="flex w-full flex-col gap-1">
        <Typography variant="label" size="medium" weight="medium">
          {details}
        </Typography>
        <div className="flex items-center gap-1.5">
          {procedure_code && (
            <>
              <Typography variant="p" size="xs" weight="medium" color="neutral-700">
                {procedure_code}
              </Typography>
            </>
          )}
          {diagnosis_code && (
            <>
              <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
              <Typography variant="p" size="xs" weight="medium" color="neutral-700">
                {diagnosis_code}
              </Typography>
            </>
          )}
          {type && (
            <>
              <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
              <Typography variant="p" size="xs" weight="medium" color="neutral-700">
                {type}
              </Typography>
            </>
          )}
          {showQty && (
            <Typography variant="p" size="xs" weight="medium" color="neutral-700">
              ×{qty}
            </Typography>
          )}
        </div>
        {hasNested && (
          <div className="flex flex-col gap-0.5">
            {ia(nestedProcedures) && (
              <NestedItems
                items={nestedProcedures}
                type="Procedure"
                isLastGroup={!ia(nestedProducts)}
              />
            )}
            {ia(nestedProducts) && <NestedItems items={nestedProducts} type="Product" />}
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="flex min-w-52 flex-col gap-1 px-2">
      <Typography variant="label" size="medium" weight="medium">
        {details}
      </Typography>
      <div className="flex items-center gap-1.5">
        {type && (
          <>
            <Typography
              variant="p"
              size="xs"
              weight="medium"
              color="neutral-700"
              className="whitespace-nowrap">
              {insuranceTypes.find((item) => item.value === type)?.label || type}
            </Typography>
          </>
        )}
        {showQty && (
          <Typography
            variant="p"
            size="xs"
            weight="medium"
            color="neutral-700"
            className="whitespace-nowrap">
            ×{qty}
          </Typography>
        )}
        {!isSameDate && from_date && (
          <>
            <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
            <Typography variant="p" size="xs" weight="medium" color="neutral-700">
              {from_date}
            </Typography>
          </>
        )}
      </div>
      {hasNested && (
        <div className="flex flex-col gap-0.5">
          {ia(nestedProcedures) && (
            <NestedItems
              items={nestedProcedures}
              type="Procedure"
              isLastGroup={!ia(nestedProducts)}
            />
          )}
          {ia(nestedProducts) && <NestedItems items={nestedProducts} type="Product" />}
        </div>
      )}
    </div>
  );
};

export default DetailsCell;
